import React, {useEffect, useState} from 'react';
import { Row, Col, Card, Form, Table, Pagination, Spinner } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

import { Security } from "../../../../models/security";
import SecurityService from "../../../../services/security-service";
import { toCurrency } from '../../../../helpr/helper';

import paginationLeftIcon from "../../../../assets/pagination-arrow-left.svg";
import paginationRightIcon from "../../../../assets/pagination-arrow-right.svg";

import usePagination from "../../../../hooks/use-pagination";
import styles from './adcu-security-list.module.scss';
import ADCUFilterSecurity from "./components/adcu-filter-security";


const ADCUSecurityList = () => {
  const headers = [{ key: 'securityName', value: 'Security Name', filter: true, class: '' },
    { key: 'securityId', value: 'ISIN/Security Code', filter: false, class:'' },
    { key: '', value: 'Issue Amount', filter: false, class: 'right-aligned' },
    { key: '', value: 'Offer Period', filter: false, class: '' }];

  const securityService = new SecurityService();
  const [securityListState, setSecurityListState] = useState({
    default: [],
    filtered: []
  })
  const [isLoading, setIsLoading] = useState(true);
  const pagedData = usePagination(securityListState.filtered,10);
  const navigate = useNavigate();
  const pages = Array(pagedData.maxPage).fill().map((_, i) =>
    <Pagination.Item
      key={i+1}
      active={(i+1) === pagedData.currentPage}
      onClick={() => pagedData.jump(i+1)}>
      {i+1}
    </Pagination.Item>);

  useEffect(()=>{
    const getAllSecurities = async () => {
      setIsLoading(true);
      const result = await securityService.getAllSecurities();
      const securityList = result.map( s => new Security(s));
      setSecurityListState({
        ...securityListState,
        default: securityList,
        filtered: securityList
      });
      setIsLoading(false);
    }
    getAllSecurities();
  }, [])

  const handleSecurityClick = (id) => {
    navigate(`/securities/${id}`);
  }

  return (
    <div className={styles['adcu-security-list']}>
      <Row>
        <Col>
          <Card className={styles['content']}>
            <Card.Header style={{padding: '0px'}}>
              <h1>Securities</h1>
            </Card.Header>
            <Card.Body>
              <ADCUFilterSecurity headers={headers} setPage={pagedData.jump} setSecurityList={setSecurityListState} />
              <Table responsive>
                <thead>
                  <tr>
                    { headers.map((header, _) => <th>{header['value']}</th> ) }
                  </tr>
                </thead>
                <tbody>
                  {
                    pagedData.currentData().map((data, _)=>{
                      return(
                        <tr id={data['securityId']}>
                          <td className={styles['security-name']} onClick={()=>handleSecurityClick(data['securityId'])}>
                            <img className={styles['title-icon']} src={`${process.env.REACT_APP_ASSETS_URL}${data.iconUrlSrc}`}/>
                            <span className={styles['security-name-span']}>{data.securityName}<br />
                            <span className={styles['issuer-span']}>{data.issuer}</span>
                          </span>
                          </td>
                          <td id={data['securityId']} onClick={()=>handleSecurityClick(data['securityId'])}>
                            {data['securityId'].toUpperCase()}
                          </td>
                          <td id={data['securityId']} className={styles['currency']} onClick={()=>handleSecurityClick(data['securityId'])}>
                            {toCurrency(data['offerSize'])}
                          </td>
                          <td id={data['securityId']} onClick={()=>handleSecurityClick(data['securityId'])}>
                            {data['offerDate']}-{data['offerCloseDate']}
                          </td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </Table>
              { pagedData.maxPage > 0? <Pagination>
                <Pagination.First
                  onClick={() => pagedData.jump(1)}
                  disabled={pagedData.currentPage === 1}>
                  <img alt="FIRST" src={paginationLeftIcon}/>
                </Pagination.First>
                <Pagination.Prev
                  onClick={() => pagedData.jump(pagedData.currentPage - 1)}
                  disabled={pagedData.currentPage === 1}>
                  PREV
                </Pagination.Prev>
                { pages }
                <Pagination.Next
                  onClick={() => pagedData.jump(pagedData.currentPage + 1)}
                  disabled={pagedData.currentPage === pagedData.maxPage}>
                  NEXT
                </Pagination.Next>
                <Pagination.Last
                  onClick={() => pagedData.jump(pagedData.maxPage)}
                  disabled={pagedData.currentPage === pagedData.maxPage}>
                  <img alt="LAST" src={paginationRightIcon}/>
                </Pagination.Last>
              </Pagination>:
              isLoading ? 
              <div className={styles['no-data']}><Spinner animation="border" /></div> :
              <div className={styles['no-data']}>No Securities to display</div>}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ADCUSecurityList;
